export const API_KEY = "c405dd59d0f6c3a33613ea5f3006fb27";
export const API_URL = 'https://api.themoviedb.org/3/';
export const IMAGE_BASE_URL = 'http://image.tmdb.org/t/p/';
export const IMAGE_SIZE = 'w200';
export const LANGUAGE = 'ko-KR';
